import { config } from 'config'

export const regions = [
  {
    name: 'Татары',
    image: require('./assets/1-Tatary.webp'),
    imageHover: require('./assets/1-Tatary-hover.webp'),
    link: config.links.Татары,
  },
  {
    name: 'Коми',
    image: require('./assets/2-Komi.webp'),
    imageHover: require('./assets/2-Komi-hover.webp'),
    imageInactive: require('./assets/2-Komi-inactive.webp'),
    imageInactiveHover: require('./assets/2-Komi-inactive_hover.webp'),
    link: config.links.Коми,
  },
  {
    name: 'Буряты',
    image: require('./assets/3-Buryaty.webp'),
    imageHover: require('./assets/3-Buryaty-hover.webp'),
    imageInactive: require('./assets/3-Buryaty-inactive.webp'),
    imageInactiveHover: require('./assets/3-Buryaty-inactive_hover.webp'),
    link: config.links.Бурятия,
  },
  {
    name: 'Саха',
    image: require('./assets/4-Sakha.webp'),
    imageHover: require('./assets/4-Sakha-hover.webp'),
    imageInactive: require('./assets/4-Sakha-inactive.webp'),
    imageInactiveHover: require('./assets/4-Sakha-inactive_hover.webp'),
    link: config.links.Caxa,
  },
]
